module.exports = "<main id=\"page__login\">\n  <section>\n    <article>\n      <h1 translate>auth.login.title</h1>\n      <hr>\n      <div [innerHTML]=\"'auth.login.description' | translate\"></div>\n      <app-login-form (login)=\"onLogin($event)\"></app-login-form>\n    </article>\n  </section>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/auth/login/login.component.html
// module id = ../../../../../src/app/auth/login/login.component.html
// module chunks = main